import {createBaseQuery} from "../helper/createBaseQuery";
import {tokenSlice} from "../slice/tokenSlice";
import {validateQueryStringParameters} from "../../helpers/api";

const BidComparsionApi = tokenSlice.injectEndpoints({
    reducerPath: "bidComparsionApi",
    baseQuery: createBaseQuery(),
    tagTypes: ["BidComparsion"],
    endpoints(builder) {
        return {
            getWFA: builder.query({
                query: (params) => ({
                    url: `BidComparison/GetComparisonWFA`,
                    params: validateQueryStringParameters(params),
                    method: "GET",
                }),
                providesTags: ["BID"],
            }),
            getDraft: builder.query({
                query: (params) => ({
                    url: `BidComparison/GetComparisonDraft`,
                    params: validateQueryStringParameters(params),
                    method: "GET",
                }),
                providesTags: ["BID"],
            }),
            getAll: builder.query({
                query: (params) => ({
                    url: `BidComparison/GetAll`,
                    params: validateQueryStringParameters(params),
                    method: "GET",
                }),
                providesTags: ["BID"],
            }),
            getHeld: builder.query({
                query: (params) => ({
                    url: `BidComparison/GetComparisonHeld`,
                    params: validateQueryStringParameters(params),
                    method: "GET",
                }),
                providesTags: ["BID"],
            }),
            getRejected: builder.query({
                query: (params) => ({
                    url: `BidComparison/GetComparisonRejected`,
                    params: validateQueryStringParameters(params),
                    method: "GET",
                }),
                providesTags: ["BID"],
            }),
            getNotReleased: builder.query({
                query: (params) => ({
                    url: `BidComparison/GetComparisonNotReleased`,
                    params: validateQueryStringParameters(params),
                    method: "GET",
                }),
                providesTags: ["BID"],
            }),
            getMyCharts: builder.query({
                query: (params) => ({
                    url: `BidComparison/GetComparisonMyCharts`,
                    params: validateQueryStringParameters(params),
                    method: "GET",
                }),
                providesTags: ["BID"],
            }),
            getComparsion: builder.query({
                query: (rfqMainId) => ({
                    url: `BidComparison/GetComparison?rfqMainId=${rfqMainId}`,
                    method: "GET",
                }),
                providesTags: ["BID"],
            }),
            postApproveComparison: builder.mutation({
                query: (data) => ({
                    url: "BidComparison/ApproveComparison",
                    method: "POST",
                    body: data,
                }),
                invalidatesTags: ["BID"],
            }),
            postRejectComparison: builder.mutation({
                query: (data) => ({
                    url: "BidComparison/RejectComparison",
                    method: "POST",
                    body: data,
                }),
                invalidatesTags: ["BID"],
            }),
            postSendToApproveComparison: builder.mutation({
                query: (data) => ({
                    url: "BidComparison/SendComparisonToApprove",
                    method: "POST",
                    body: data,
                }),
                invalidatesTags: ["BID"],
            }),
            postChangeComparisonStatus: builder.mutation({
                query: (data) => ({
                    url: "BidComparison/ChangeComparisonStatuses",
                    method: "POST",
                    body: data,
                }),
                invalidatesTags: ["BID"],
            }),
            postAddComparison: builder.mutation({
                query: (data) => ({
                    url: "BidComparison/AddComparison",
                    method: "POST",
                    body: data,
                }),
                invalidatesTags: ["BID"],
            }),
            postCreateOrderFromBids: builder.mutation({
                query: (data) => ({
                    url: "Bid/OrderCreateFromApproveBids",
                    method: "POST",
                    body: data,
                }),
                invalidatesTags: ["BID"],
            }),
            holdComparisonChart: builder.mutation({
                query: (data) => ({
                    url: "BidComparison/HoldBidComparison",
                    method: "POST",
                    body: data,
                }),
                invalidatesTags: ["BID"],
            }),
            postDisqualify: builder.mutation({
                query: (data) => ({
                    url: "Bid/Disqualify",
                    method: "POST",
                    body: data,
                }),
                invalidatesTags: ["BID"],
            }),
            getComparisonAttachments: builder.query({
                query: (sourceId) => ({
                    url: `Attachment/GetBidComparisonAttachments?sourceId=${sourceId}`,
                    method: "GET",
                }),
                providesTags: ["Attachment"],
            }),
            getCommercialAttachments: builder.query({
                query: (sourceId) => ({
                    url: `Attachment/GetBidCommercialAttachments?sourceId=${sourceId}`,
                    method: "GET",
                }),
                providesTags: ["Attachment"],
            })
        };
    },
});

export const {
    useGetDraftQuery,
    useGetWFAQuery,
    useGetAllQuery,
    useGetHeldQuery,
    useGetRejectedQuery,
    useGetNotReleasedQuery,
    useGetMyChartsQuery,
    useGetComparsionQuery,
    useGetComparisonAttachmentsQuery,
    useGetCommercialAttachmentsQuery,
    usePostChangeComparisonStatusMutation,
    usePostSendToApproveComparisonMutation,
    usePostAddComparisonMutation,
    usePostCreateOrderFromBidsMutation,
    useHoldComparisonChartMutation,
    usePostDisqualifyMutation,
} = BidComparsionApi;
export {BidComparsionApi};
